import { render } from "./CommonLoading.vue?vue&type=template&id=672a62e2&scoped=true"
import script from "./CommonLoading.vue?vue&type=script&lang=js"
export * from "./CommonLoading.vue?vue&type=script&lang=js"

import "./CommonLoading.vue?vue&type=style&index=0&id=672a62e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-672a62e2"

export default script